class Initiator {
    constructor() {
        this.objectsToInit = [];
    }

    register(obj) {
        this.objectsToInit.push(obj);
    }

    initAll(config) {
        Promise.all(this.objectsToInit.filter(obj => obj.init).map(obj => obj.init(config)));
    }
}

export default new Initiator();
